<template>
  <v-card
    style="cursor: pointer"
    class="mt-3 pa-2 d-flex"
    :color="status.bgColor"
    outlined
    @click="handleClickResponse"
    :disabled="
      command.status === 'connected' ||
      command.status === 'process' ||
      command.status === null
    "
  >
    <div class="mr-3">
      <v-icon :color="status.color">{{ status.icon }}</v-icon>
    </div>
    <div class="ml-3">
      <div>{{ employee.firstname_th }} {{ employee.lastname_th }}</div>
      <div style="font-size: 14px; color: #757575">
        <span> ตำแหน่ง {{ employee.position.title_th }} </span>
        <span>
          {{ employee.employee_code }}
        </span>
      </div>
      <div :class="`${status.color}--text`">{{ status.text }}</div>
    </div>
    <v-spacer></v-spacer>
    <v-icon v-if="command.status === 'success' || command.status === 'fail'"
      >mdi-chevron-right</v-icon
    >
  </v-card>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: {
    employee: {
      type: Object,
      required: true,
    },
    hardware: {
      type: Object,
      required: true,
    },
    syncCode: {
      type: String,
      required: true,
    },
    identifyMode: {
      type: Number,
    },
  },

  data() {
    return {
      command: {
        status: null,
      },
      syncJobId: null,
    }
  },

  computed: {
    status() {
      if (this.command.status === 'connected') {
        return {
          icon: 'mdi-swap-horizontal',
          color: 'info',
          bgColor: 'blue lighten-5',
          text: 'กำลังติดต่อ Device',
        }
      } else if (this.command.status === 'process') {
        return {
          icon: 'mdi-autorenew',
          color: 'info',
          bgColor: 'blue lighten-5',
          text: 'รอ Device ดำเนินการ',
        }
      } else if (this.command.status === 'success') {
        return {
          icon: 'mdi-check-circle-outline',
          color: 'success',
          bgColor: 'green lighten-5',
          text: 'สำเร็จ',
        }
      } else if (this.command.status === 'fail') {
        return {
          icon: 'mdi-close-circle-outline',
          color: 'error',
          bgColor: 'red lighten-5',
          text: 'ไม่สำเร็จ',
        }
      } else {
        return {
          icon: '',
          color: '',
          bgColor: '',
          text: '',
        }
      }
    },
  },

  mounted() {
    const { company_uuid } = this.$store.state.authentication.company

    const payload = {
      company_uuid,
      hardware_model_code: this.hardware.hardware_model.hardware_model_code,
      sync_code: this.syncCode,
      body: {
        hardware_uuid: this.hardware.hardware_uuid,
        data: {
          employee_uuid: this.employee.employee_uuid,
          identify_mode: this.identifyMode,
        },
      },
    }

    this.createDeviceJob(payload)
      .then((res) => {
        this.command = {
          status: 'connected',
        }
        this.syncJob(res.sync_job_uuid)
      })
      .catch((error) => {
        if (error.response && error.response.data) {
          this.command = {
            status: 'fail',
            date: new Date(),
            responseData: {
              error_type: 'fail',
              error_message: error.response.data.message || 'created job fail',
            },
          }
        } else {
          this.command = {
            status: 'fail',
          }
        }
      })
  },

  methods: {
    ...mapActions({
      createDeviceJob: 'employee/createDeviceJob',
      fetchJob: 'hardware/fetchJob',
      userAcknowledge: 'hardware/userAcknowledge',
    }),

    syncJob(sync_job_uuid) {
      this.syncJobId = setInterval(() => {
        this.fetchJob(sync_job_uuid).then((res) => {
          this.analyzeStatus(res)
        })
      }, 1000)
    },

    clearSyncJob() {
      clearInterval(this.syncJobId)
    },

    analyzeStatus(res) {
      if (res.done_datetime && res.is_response_success) {
        if (
          this.syncCode === 'delete_employee' ||
          this.syncCode === 'set_employee'
        ) {
          this.command = {
            status: 'success',
            date: res.done_datetime,
            responseData: null,
          }
        } else {
          this.command = {
            status: 'success',
            date: res.done_datetime,
            responseData: res.response_json,
          }
        }
        this.clearSyncJob()
        // User Acknowledge
        if (res.user_acknowledge_datetime === null) {
          this.acknowledge(res.sync_job_uuid)
        }
      } else if (res.done_datetime && !res.is_response_success) {
        this.command = {
          status: 'fail',
          date: res.done_datetime,
          responseData: {
            error_type: res.response_json?.error_type || 'fail',
            error_message:
              res.response_json?.error_message || 'precess job fail',
          },
        }
        this.clearSyncJob()
        // User Acknowledge
        if (res.user_acknowledge_datetime === null) {
          this.acknowledge(res.sync_job_uuid)
        }
      } else if (res.notice_datetime) {
        this.command = {
          status: 'process',
          date: res.notice_datetime,
        }
      }
    },

    acknowledge(sync_job_uuid) {
      this.userAcknowledge(sync_job_uuid).catch((error) => {
        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      })
    },

    handleClickResponse() {
      this.$emit('onClickResponse', { ...this.command })
    },
  },

  beforeDestroy() {
    this.clearSyncJob()
  },
}
</script>
